import React from 'react'
import EnumEditor from './EnumEditor'
import EnumValueEditor from './EnumValueEditor'

/**
 * Creates an editor for an enum or an enum value
 * @param {string} type 'enum' or 'value'
 * @param {object} item the enum
 * @param {function} itemActions api-redux base actions to call update on
 * @param {object} [value] the value, if applicable
 */
function createEditor( opts = {} ) {
  const { type } = opts
  if ( type === 'enum' ) {
    return <EnumEditor {...opts} />
  }
  if ( type === 'value' ) {
    return <EnumValueEditor {...opts} />
  }
  return null
}

module.exports = { createEditor }
